import styled from "styled-components";

export const Container = styled.div`
  position: relative;

  display: flex;
  height: 73%;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 812px) {
    height: auto;
    width: 100%;
    flex-direction: column;
  }
`

export const Form = styled.form`
  display: block;
  width: 30%;
  height: auto;
`

export const ButtonArea = styled.div`
  margin-top: 1em;
  position: relative;
  left: 50%;

  transform: translateX(-70%);
  width: 50%;
  height: 50px;
`